export default "__VITE_ASSET__4a145bcb__"